import { render } from "./commonFooter.vue?vue&type=template&id=06153266"
import script from "./commonFooter.vue?vue&type=script&lang=js"
export * from "./commonFooter.vue?vue&type=script&lang=js"

import "./commonFooter.vue?vue&type=style&index=0&id=06153266&lang=less"

import exportComponent from "D:\\aj项目\\code\\广饶轮胎\\广饶轮胎电子会刊\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__